// Method: Convert date to '08:30 am'
export const useFormatNumber = (number?: number) => {
    return new Intl.NumberFormat('id-ID').format(number || 0)
}